export const OPERATORS = {
	EQUAL: '=',
	NOT_EQUAL: '!=',
	LIKE: '%',
	GREATER_THAN: '>',
	GREATER_THAN_EQUAL: '>=',
	LESS_THAN: '<',
	LESS_THAN_EQUAL: '<=',
	BETWEEN: 'between',
	NOT_EXIST: 'notExist',
};

export const OPERATOR_OPTIONS = {
	NUMBER: [
		OPERATORS.EQUAL,
		// OPERATORS.NOT_EQUAL,
		// OPERATORS.GREATER_THAN,
		OPERATORS.GREATER_THAN_EQUAL,
		// OPERATORS.LESS_THAN,
		OPERATORS.LESS_THAN_EQUAL,
		OPERATORS.BETWEEN,
	],
	ALLOCATED_CARRIERS: [
		OPERATORS.GREATER_THAN_EQUAL,
		OPERATORS.EQUAL,
		OPERATORS.LESS_THAN_EQUAL,
		OPERATORS.BETWEEN,
	],
	STRING: [OPERATORS.LIKE, OPERATORS.EQUAL, OPERATORS.NOT_EQUAL],
	DATE: [OPERATORS.BETWEEN],
	VOLUME: [
		OPERATORS.EQUAL,
		OPERATORS.GREATER_THAN_EQUAL,
		OPERATORS.LESS_THAN_EQUAL,
		OPERATORS.BETWEEN,
	],
	LOCATION: [OPERATORS.EQUAL, OPERATORS.NOT_EQUAL],
	STAGE: [OPERATORS.EQUAL, OPERATORS.NOT_EQUAL],
	ARCHIVED: [OPERATORS.EQUAL, OPERATORS.NOT_EQUAL],
	JOB_STATUS: [OPERATORS.EQUAL, OPERATORS.NOT_EQUAL],
	TRAILER_TYPE: [OPERATORS.EQUAL, OPERATORS.NOT_EQUAL],
	PROJECT_TYPE: [OPERATORS.EQUAL, OPERATORS.NOT_EQUAL],
	PROJECT: [OPERATORS.EQUAL, OPERATORS.NOT_EQUAL, OPERATORS.NOT_EXIST],
	COMPANY: [OPERATORS.EQUAL, OPERATORS.NOT_EQUAL],
	USER_STATUS: [OPERATORS.EQUAL, OPERATORS.NOT_EQUAL],
	USER_ROLE: [OPERATORS.EQUAL, OPERATORS.NOT_EQUAL],
};

export const LOAD_VOLUME_DURATION = ['Day', 'Week', 'Month', 'Year'];

export const INPUT_TYPES = {
	ALLOCATED_CARRIERS: 'allocatedCarriers',
	CUSTOMER: 'customer',
	DATE: 'date',
	LOCATION: 'location',
	NUMBER: 'number',
	STRING: 'string',
	TRAILER_TYPE: 'trailerType',
	USERS_LIST: 'usersList',
	VOLUME: 'volume',
	BOOLEAN: 'boolean',
	STATE: 'statesList',
	STAGE: 'stage',
	JOB_STATUS: 'jobStatus',
	IMPORT_STATS_JOB_STATUS: 'importStatsJobStatus',
	PROJECT_TYPE: 'projectType',
	CARRIER: 'carrier',
	PROJECT: 'project',
	COMPANY: 'company',
	CARRIER_ACCOUNTS: 'carrierAccounts',
	USER_STATUS: 'userStatus',
	USER_ROLE: 'userRole',
};

export const LOCATION_OPERATORS_LABEL = {
	[OPERATORS.EQUAL]: 'is',
	[OPERATORS.NOT_EQUAL]: 'is not',
};

export const STAGE_OPERATORS_LABEL = {
	[OPERATORS.EQUAL]: 'is',
	[OPERATORS.NOT_EQUAL]: 'is not',
};

export const ARCHIVED_OPERATORS_LABEL = {
	[OPERATORS.EQUAL]: 'is',
	[OPERATORS.NOT_EQUAL]: 'is not',
};

export const JOB_STATUS_OPERATORS_LABEL = {
	[OPERATORS.EQUAL]: 'is',
	[OPERATORS.NOT_EQUAL]: 'is not',
};

export const EQUAL_NOT_EQUAL_TYPES_LABEL = {
	[OPERATORS.EQUAL]: 'is',
	[OPERATORS.NOT_EQUAL]: 'is not',
};

export const PROJECT_OPERATORS_LABEL = {
	[OPERATORS.EQUAL]: 'is',
	[OPERATORS.NOT_EQUAL]: 'is not',
	[OPERATORS.NOT_EXIST]: 'does not exist',
};

export const COMPANY_OPERATORS_LABEL = {
	[OPERATORS.EQUAL]: 'is',
	[OPERATORS.NOT_EQUAL]: 'is not',
};

/**
 * CURRENCY DATA TYPE USAGE GUIDE
 *
 * Use this guide to determine which currency data type to use in tabbed tables:
 *
 * 1. 'currency' - For values stored in CENTS (legacy format)
 *    - Automatically divides by 100 before displaying
 *    - Used for: bids (amount, allInPrice), older financial data
 *    - Example: 155000 cents → $1,550.00
 *
 * 2. 'currencyAsIs' - For values stored in DOLLARS (modern format)
 *    - No conversion needed, displays value as-is with currency formatting
 *    - Used for: offer analytics rates, load pricing, newer financial data
 *    - Example: 1550.0 dollars → $1,550
 *
 * Alternative approaches:
 * - Use 'dollarsDisplay' pipe for cent-based values in custom templates
 * - Use direct 'currency' pipe for dollar-based values in custom templates
 *
 * When in doubt, check the API documentation or test data to determine
 * if values are in cents or dollars.
 */

// Normalize anything (dayjs/moment/Date/ISO string/YYYY-MM-DD) into 'YYYY-MM-DD'
export const TO_YMD = (v: any): string | null => {
	if (!v) return null;

	// String inputs
	if (typeof v === 'string') {
		// If it's an ISO-like string, slice first 10 chars; if already YYYY-MM-DD, this is a no-op.
		return v.length >= 10 ? v.slice(0, 10) : v;
	}

	// dayjs/moment-like (has .format)
	if (typeof (v as any).format === 'function') {
		return (v as any).format('YYYY-MM-DD');
	}

	// Native Date
	if (v instanceof Date && !isNaN(v.getTime())) {
		const y = v.getFullYear();
		const m = String(v.getMonth() + 1).padStart(2, '0');
		const d = String(v.getDate()).padStart(2, '0');
		return `${y}-${m}-${d}`; // local calendar date — no timezone math
	}

	// Fallback: last-ditch try to stringify safely
	try {
		const s = String(v);
		return s.length >= 10 ? s.slice(0, 10) : null;
	} catch {
		return null;
	}
};
